import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class SocialMediaMarketing extends Component {
	render() {
		return (
<div>
				<Header
					seoTitle="Social Media Marketing"
					title={"social media marketing"}
					image={require('./image-7.jpg')}
				/>
				<div className="entry-content page-blog">

				<div className="container-fluid">
                       			<h2 className="outline text-center">
                            			<div className="line"></div>
                            			<div className="title">
                               			   <img
                                    			src={require("./moshi-icon.png")}
                                    			alt="Icon"
                                    			width="48"
                                    			style={{
                                    			marginTop: -18,
                                    			marginBottom: -12,
                                    			marginRight: 12
                                		   }}/>
                               			 Social Media Marketing
                            			</div>
                       			 </h2>
                    		</div>

					
					<div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
								
								<p>Social Media Marketing is a fantastic way to get your ads in front of your customers. Depending on your business and campaign goals, there are a range of options you can choose from. 
</p>

								<h4>A lot of businesses don't realise that there is a science behind targeting through social platforms. Our team have the data to create fantastic marketing strategies for you online.</h4>

<p>Social Media Marketing methods we run are:</p>
								
        <ul class="with-icons">
              <li>Instagram Shopping ads</li>
<li>Facebook Carousel Product ads</li>
<li>Facebook Boosted Posts</li>
<li>Portrait ads for Snapchat or Instagram Stories</li>
<li>LinkedIn ads</li>
<li>Facebook Remarketing ads</li>      
<li>Instagram Remarketing ads</li>
<li>Video Advertising (YouTube/TrueView)</li>

        </ul>
    <p>Our team at Moshi Moshi Marketing has over 10 years combined experience in the field of Social Media Marketing - dealing with brands of a local and international level. We will take the hard work out of inserting your Facebook Pixel into your website, creating your ads, and writing your titles, descriptions and headlines for your ads.
</p>
<h4>WA’s Facebook Remarketing Experts</h4>
<p>Remarketing refers to targeting those that have already been on a specific page of your website, or have taken an action on your site. At Moshi moshi, we can create campaigns that follow these people with ads targeted at completing a purchase or sign up, notifying them of perks of your business, or pulling them back in with an exclusive sale. These ads are cost effective and have a great conversion rate. 
</p>


<p>
</p>

<img src={require('./insta.png')} style={{padding: 30}}  height="375" width="350" alt="Example of Instagram Advertising" className="align-centre" align="centre" />
<img src={require('./social-mark.png')} style={{padding: 30}} height="375" width="350" alt="Example of Carousel ad on Facebook" className="align-centre" align="centre" />
<img src={require('./linkedin.png')} style={{padding: 30}} height="375" width="350" alt="LinkedIn Advertising for B2B" className="align-centre" align="centre" />

<br></br>
<hr></hr>
<h2>Related Services</h2>

 <a class="btn" href="https://www.moshi.com.au/whatwedo/social-media-management">Social Media Management</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/google-advertising">Google Advertising</a>	
<a class="btn" href="https://www.moshi.com.au/whatwedo/ecommerce-and-online-shops">Ecommerce and Online Shops</a>
		
		
<a class="btn" href="https://www.moshi.com.au/whatwedo/photography-and-video-shoots">Photography and Video Shoots</a>		
<a class="btn" href="https://www.moshi.com.au/whatwedo/video-production-and-advertising">Video Production and Advertising</a>
<a class="btn" href="https://www.moshi.com.au/whatwedo/website-development">Website Development</a>		

						
							</div>
							{/* <div className="col-lg-4">
								<Sidebar />
							</div> */}
						</div>
<hr></hr>
<br></br>

<h3>If getting your product involved in digital marketing is on your to-do list this year, come and chat to Moshi Moshi about the best route to take. </h3>
					</div>
				</div>

			</div>
		);
	}
}

export default SocialMediaMarketing;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/SocialMediaMarketing.js